const i = {
  decimal: /^((0(\.\d{0,2})?)|((?!0)\d+(\.\d{0,2})?))$/,
  numeric: /^\d+$/,
  nowhitespace: /^\S+$/
}, n = {
  decimal: [",", "."],
  nowhitespace: [/\s/g, ""]
};
function a({ value: t, pattern: c }) {
  return c && n[c] && (t = t.replace(...n[c])), !!(!c || t === "" || i[c].test(t));
}
function m({ value: t, pattern: c, field: e }) {
  let s = t;
  if (c && n[c] && (s = t.replace(...n[c]), e && s !== t)) {
    const o = e.selectionStart, r = e.selectionEnd;
    e.value = s, e.selectionStart = o - 1, e.selectionEnd = r - 1;
  }
  return s;
}
export {
  a as c,
  m as f
};
